






import { Vue, Component, Prop } from 'vue-property-decorator';
import ClassicEditor from 'ckeditor4-vue';
import { URIs } from '../../../src_server/common/URIs';
@Component({ components: {} })
export default class Editor extends Vue {
  @Prop({ default: '' })
  private value!: string;

  private editor = ClassicEditor;

  get editorData() {
    return this.value;
  }

  set editorData(value: any) {
    this.$emit('input', value);
  }
  editorConfig = {
    extraPlugins: 'image2', // 'image2,uploadimage',

    // Configure your file manager integration. This example uses CKFinder 3 for PHP.
    // filebrowserBrowseUrl: '/ckfinder/3.4.5/ckfinder.html',
    // filebrowserImageBrowseUrl: '/apps/ckfinder/3.4.5/ckfinder.html?type=Images',
    // filebrowserUploadUrl: '/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files',
    // filebrowserImageUploadUrl: URIs.EDITOR_FILE_UP.path + '?user_id=ADMIN', //'/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Images',

    // Upload dropped or pasted images to the CKFinder connector (note that the response type is set to JSON).
    // uploadUrl: '/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',

    // Reduce the list of block elements listed in the Format drop-down to the most commonly used.
    format_tags: 'p;h1;h2;h3;pre',

    // Simplify the Image and Link dialog windows. The "Advanced" tab is not needed in most cases.
    removeDialogTabs: 'image:advanced;link:advanced',

    height: 450,
  };
}
